module.exports = require("core-js/library/fn/object/keys");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/keys.js
// module id = 40
// module chunks = 35783957827783 52252321336229